import {hexToRGB, tailwindConfig} from "../../../../mosaic/utils/Utils.js";
import React, {useEffect, useState} from "react";
import {LeadCalculationApi} from "../../../../api/authority/generated/index";
import {useTranslation} from "react-i18next";
import LeadsByDateChart from "./LeadsByDateChart.jsx";
import LoadingComponent from "../../../../components/LoadingComponent.jsx";
import useAuthorityConfiguration from "../../../../api/utilities/useAuthorityConfiguration.js";
import toast from "react-hot-toast";
import {useErrorTranslation} from "../../../../api/utilities/translateErrorMessage.js";

export default function LeadsByDateCard({project, title, since, until}) {

    let {t} = useTranslation();
    let {et} = useErrorTranslation();

    let [data, setData] = useState(null);

    let authorityConfiguration = useAuthorityConfiguration();

    useEffect(() => {
            new LeadCalculationApi(authorityConfiguration)
                .dateOverview({
                    projectId: project.id,
                    erpFilter: {
                        since: since.format('YYYY-MM-DD'),
                        until: until.format('YYYY-MM-DD'),
                        selectedDomainIds: [],
                        selectedCentreIds: [],
                    },
                }).then(setData).catch(e => et(e).then(toast.error));
        },
        [since.format('YYYY-MM-DD'), until.format('YYYY-MM-DD'), project.id]
    );

    let [chart, setChart] = useState(null);

    useEffect(() => {

        if (!data) {
            setChart(null);
            return;
        }

        setChart(null);

        let labels = [];
        let values = [];

        // noinspection JSUnresolvedReference
        for (let key in data.currentGranular) {
            labels.push(key);
            // noinspection JSUnresolvedReference
            values.push(data.currentGranular[key]);
        }

        data.chartData = {
            labels: labels,
            datasets: [
                // Line
                {
                    data: values,
                    fill: true,
                    backgroundColor: `rgba(${hexToRGB(tailwindConfig().theme.colors.emerald[500])}, 0.08)`,
                    borderColor: tailwindConfig().theme.colors.emerald[500],
                    borderWidth: 2,
                    tension: 0,
                    pointRadius: 0,
                    pointHoverRadius: 3,
                    pointBackgroundColor: tailwindConfig().theme.colors.emerald[500],
                    pointHoverBackgroundColor: tailwindConfig().theme.colors.emerald[500],
                    pointBorderWidth: 0,
                    pointHoverBorderWidth: 0,
                    clip: 20,
                },
            ],
        };

        setChart(data);
    }, [data]);

    return (
        <div
            className="comp__roundedBox flex flex-col justify-between col-span-full sm:col-span-6 xl:col-span-3 bg-white dark:bg-slate-800 shadow-lg rounded-sm border border-slate-200 dark:border-slate-700"
        >
            <header className={''}>
                <div
                    className={'px-5 py-4 border-b border-slate-100 dark:border-slate-700 flex items-center'}>
                    <h2 className={'font-semibold text-slate-800 dark:text-slate-100'}>
                        {title}
                    </h2>
                </div>
                <span
                    className="pl-5 text-2xl font-bold text-slate-800 dark:text-slate-100 mb-1"
                >
                        {chart?.currentTotal ?? '-'}
                    </span>
                <span className="text-sm">
                                &nbsp;/&nbsp;
                    {((chart?.currentTotal ?? 0) + (chart?.unverifiedCurrentTotal ?? 0))}
                    </span>
            </header>

            <LoadingComponent loading={!chart?.chartData}>
                <LeadsByDateChart data={{...chart?.chartData}} width={286} height={98}/>
            </LoadingComponent>
        </div>
    );
}